import React, { useState } from "react";
import logo from "../images/Assets/logo.png";
import { HiMenu } from "react-icons/hi";
import { Link } from "react-router-dom";
import { RiCloseFill } from "react-icons/ri";
import Drawer from "react-modern-drawer";

export default function Header() {
  const komodoUser = JSON.parse(localStorage.getItem("komodoUser"));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="md:px-6 xl:px-10 px-28 py-7 flex items-center justify-between">
        <Link to="/home"><img src={logo} alt="logo" className="md:w-[110px] w-auto cursor-pointer" /></Link>

        <ul className="flex xl:hidden items-center gap-10 text-[16px] text-[#544D68] font-gilroyRegular cursor-pointer">
          <li onClick={() => handleScrollToSection("about")}>About Us</li>
          <li onClick={() => handleScrollToSection("features")}>Features</li>
          <li onClick={() => handleScrollToSection("ourproduct")}>Our Products</li>
          <li onClick={() => handleScrollToSection("service")}>Services</li>
          <li onClick={() => handleScrollToSection("testimonials")}>Testimonials</li>
          <Link to="/pricing">
            <li>Pricing</li>
          </Link>
        </ul>

        <div className="flex items-center gap-3 xl:hidden">
          {komodoUser?.email !== null &&
            komodoUser?.email !== undefined &&
            komodoUser?.email !== "" ? null : (
            <>
              <Link to="/login">
                <div className="border border-[#7846F0] text-[14px] md:text-[16px] text-[#7846F0] font-gilroySemibold py-1.5 px-3 rounded-full cursor-pointer">
                  Login
                  {/* Book a free call */}
                </div>
              </Link>
              <Link to="/signup">
                <div className="border border-[#7846F0] text-[14px] md:text-[16px] text-[#7846F0] font-gilroySemibold py-1.5 px-3 rounded-full cursor-pointer">
                  Sign up
                </div>
              </Link>
            </>
          )}
          <Link to="/chat?page=0">
            <div className="border border-[#7846F0] text-[14px] md:text-[16px] text-[#7846F0] font-gilroySemibold py-1.5 px-3 rounded-full cursor-pointer">
              Try Now
            </div>
          </Link>
        </div>
        <HiMenu className="hidden text-[20px] cursor-pointer xl:block" onClick={toggleDrawer} />
      </div>
      <div className="xl:block hidden">
        <Drawer
          open={isDrawerOpen}
          onClose={toggleDrawer}
          direction="right"
          className="chatDrawer"
        >
          <div className="font-cerebri w-full">
            <div
              className="bg-[#7846F0] p-2 rounded-full w-fit  absolute right-3 top-5"
              onClick={toggleDrawer}
            >
              <RiCloseFill className="text-[23px] text-[#fff]" />
            </div>
            <div className="p-5 mt-3">
              <ul className="flex flex-col gap-7 text-[16px] text-[#544D68] font-gilroyRegular cursor-pointer">
                <li>About Us</li>
                <li>Features</li>
                <li>Our Products</li>
                <li>Services</li>
                <li>Testimonials</li>
                <Link to="/pricing">
                  <li>Pricing</li>
                </Link>
              </ul>
              <hr className="mt-3" />
              <div className="mt-5">
                {komodoUser?.email !== null &&
                  komodoUser?.email !== undefined &&
                  komodoUser?.email !== "" ? null : (
                  <>
                    <Link to="/login">
                      <div className="border border-[#7846F0] text-[14px] md:text-[16px] text-[#7846F0] font-gilroySemibold py-1.5 px-3 rounded-full cursor-pointer text-center">
                        Login
                        {/* Book a free call */}
                      </div>
                    </Link>
                    <Link to="/signup">
                      <div className="border border-[#7846F0] text-[14px] md:text-[16px] text-[#7846F0] font-gilroySemibold py-1.5 px-3 rounded-full cursor-pointer my-5  text-center">
                        Sign up
                      </div>
                    </Link>
                  </>
                )}

                <Link to="/chat?page=0">
                  <div className="border border-[#7846F0] text-[14px] md:text-[16px] text-[#7846F0] font-gilroySemibold py-1.5 px-3 rounded-full cursor-pointer text-center">
                    Try Now
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
}
